import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import NewGif from "../../assets/new_icon.gif";
import JisDialogForm from "../../components/formdialog";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";

function CourtRecorderCases() {
  const navigate = useNavigate();
  const { eventtype } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isCmc, setIsCmc] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [roleCase, setRoleCase] = useState("all");
  const [caseStatus, setCaseStatus] = useState("pending");
  const [schedule, setSchedule] = useState({});
  const [judge, setJudge] = useState(null);
  const [processCase, setProcessCase] = useState("all");
  const [openClear, setOpenClear] = useState(false);
  const [clearCommnent, setClearComment] = useState("");
  const [caseStatusId, setCaseStatusId] = useState(137); //previously 136
  const [predate, setPredate] = useState("");
  const [pretime, setPretime] = useState("");
  const [roleName,setRoleName]=useState('Service Sheriff');
  useEffect(() => {
    //onSearch(search);
    onGetJudge();
  }, []);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
   /*  if(roles.length==0){
      onLoadRoles()
    } */
  }, [pageIndex, pageSize, search, caseStatus]);

  const onCaseStateChange = (s) => {
    setCases([]);
    setCaseStatus(s);
    
  };
  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedCases };
    if (value) {
      sel.add(opt.caseId);
      updateSel[opt.caseId] = opt;
    } else {
      sel.delete(opt.caseId);
      delete updateSel[opt.caseId];
    }
    setSelected(new Set(sel));
    setSelectedCases(updateSel);
    console.log(Object.keys(updateSel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/ongoing-hearing/${caseStatus}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

 

  

  const onGetJudge = async () => {
    //for account registration

    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getjudgedetails-profile`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      var judge = data.judge;
      if (judge != null) {
        setJudge({
          ...judge,
          courtName: data.courtname,
          judgeType: data.judgetype,
          lastRank: data.lastRank,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setOpenCase(true);
  };

  const onRecorder = (opt) => {
    navigate(`/court-recorder/${opt.id}`)
 
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onCloseClear = () => {
    setActive(null);
    setIndex(-1);
    setOpenClear(false);
  };

  const onSave = async (e) => {
    e.preventDefault();

    setErr("");
    // var eventtype=isCmc==true?'CMC':'Trial';
    var obj = {
      ...schedule,
      eventType: eventtype,
      CaseId: active.caseId,
      CourtId: judge.courtId,
      CourtRoomId: 0,
      JudgeId: profile.id,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/shedule-case`, {
        method: "POST",
        body: JSON.stringify(obj),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);

        setAlert({
          open: true,
          title: "Case Schedule",
          subtitle: " Case scheduled successfully",
        });
        setPageIndex(-1); // this will auto load again
        setIsPreview(false);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };


  const onAdoption = (item, index) => {
    //load a dialog with
    setActive(item);
    setOpenClear(true);
  };

  return (
    <div>
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
        filingtype="all"
      />

      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            code="pending"
            isActive={caseStatus == "pending"}
            title="Pending"
            isRoleBased={false}
            onClick={() => onCaseStateChange("pending")}
          />
         {/*  <JisTabButton code="assigned" isActive={caseStatus=='assigned'}  title="Assigned" isRoleBased={false} onClick={()=> onCaseStateChange('assigned')}/>
            <JisTabButton code="served" isActive={caseStatus=='served'}  title="Served" isRoleBased={false} onClick={()=> onCaseStateChange('served')}/>
         <JisTabButton code="scheduled" isActive={caseStatus=='served'}  title="Accepted Cases" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('scheduled')}/>    
             <JisTabButton code="concluded" isActive={caseState=='concluded'}  title="Concluded " data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('concluded')}/>    */}
        </div>
        {caseStatus == "pending" && (
          <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Unschedule Cases</span>
                </div>
                <table class="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Filing Type</th>
                      <th className="col-medium">Classification</th>
                      <th className="col-medium">Case Age(Days)</th>
                      <th className="col-medium">Date Initiated</th>
                      <th className="col-medium">Status Level</th>
                      <th className="col-medium">Schedule Date</th>
                      <th className="col-title">Details</th>
                      <th className="col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td style={{
                            backgroundColor: `${
                              Constants.getItemById(
                                frequentData?.casecategories,
                                opt.case?.caseCategoryId
                              )?.colour
                            }`,
                          }}>{opt.case?.caseNumber || "N/A"}</td>
                          <td>{opt.case?.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.case?.caseTypeId
                            )?.caseType1 || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.casecategories,
                              opt.case?.caseCategoryId
                            )?.categoryTitle || "N/A"}
                          </td>
                          <td>
                            {moment().diff(opt.createdOn, "days") || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.case?.createdOn).format(
                              "DD MMM, YYYY"
                            ) || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casestatuses,
                              opt.case?.caseStatusId
                            )?.description || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.scheduleDate).format(
                              "DD MMM, YYYY"
                            ) || "N/A"}
                          </td>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt.case, index)}
                            >
                              View
                            </JisButton>
                          </td>
                          <td>
                            
                              <JisButton
                                variant="plain"
                                onClick={() => onRecorder(opt)}>
                               Verbatim Recording
                              </JisButton>
                           
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
        )}
      
      </div>

      <BackLoader open={loading} />

    

      {openCase && active != null && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.case?.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

     
    </div>
  );
}

export default CourtRecorderCases;
